import React, { memo } from 'react';
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';

import mapPinIcon from 'assets/map-pin.png';

const BMap = memo(({ google, coordinates, height = '25rem', iconSize = [24, 28] }) => {
  if (!coordinates.latitude || !coordinates.longitude) {
    return (
      <div className='bmap'>
        <></>
      </div>
    );
  }

  return (
    <div className='bmap'>
      <Map
        zoom={16}
        google={google}
        draggable={false}
        zoomControl={false}
        mapTypeControl={false}
        keyboardShortcuts={false}
        fullscreenControl={false}
        streetViewControl={false}
        containerStyle={{
          height,
          width: '100%',
          position: 'relative',
        }}
        initialCenter={{
          lat: coordinates.latitude,
          lng: coordinates.longitude,
        }}>
        <Marker
          icon={{
            url: mapPinIcon,
            scaledSize: new google.maps.Size(iconSize[0], iconSize[1]),
          }}
          position={{
            lat: coordinates.latitude,
            lng: coordinates.longitude,
          }}
        />
      </Map>
    </div>
  );
});

export default GoogleApiWrapper({
  apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
})(BMap);
